import React, { Component } from 'react'

import { locationTitle, locationCopy } from '../../lib/text'

import Images from '../helpers/images'
import img01 from '../../assets/images/miel-lapiquera-01.jpg'
import img02 from '../../assets/images/miel-lapiquera-02.jpg'
import img03 from '../../assets/images/miel-lapiquera-03.jpg'

class Location extends Component {
    render(){
        return (
            <div id="location">
                <div className="gallery-one">
                    <Images url={ img01 } txt={ locationTitle } />
                    <Images url={ img02 } txt={ locationTitle } />
                </div>
                <div className="gallery-two">
                    <div className="img-container">
                        <Images url={ img03 } txt={ locationTitle } />
                    </div>
                    <div className="text-container">
                        <div className="container">
                            <div></div>
                            <div>
                                <h2>{ locationTitle }</h2>
                                <p>{ locationCopy }</p>
                            </div>
                        </div>
                    </div>

                    {/* <div>
                        <Images url={ img03 } txt={ locationTitle } />
                    </div>
                    <div className="text">
                        <h2>{ locationTitle }</h2>
                        <p>{ locationCopy }</p>
                    </div> */}
                </div>
                
                
            </div>
        )
    }
}

export default Location